import {Autocomplete, Box, TextField} from "@mui/material";
import React, {useEffect, useState} from "react";
import {AutocompleteProps} from "../../components/SearchBox";
import {useGetProductByDnQuery, useGetProductQuery} from "./product_api";
import {Tables} from "../../apitypes";

import AvatarImage from "../storage/AvatarImage";


export default ({setFieldValue, value, name, error, label, workOrder}: AutocompleteProps<Tables<"product">>& { workOrder: Tables<"workOrder"> | null }) => {

    const [filter, setFilter] = useState("");
    const {data} = useGetProductByDnQuery({workOrderID: workOrder?.id, filter: filter, pageSize: 20, page: 0});

    return <Autocomplete
        id={name}
        options={data?.result || [] as Tables<"product">[]}
        sx={{minWidth: "150px"}}
        value={value}
        onChange={(e, v: Tables<"product"> | null) => {
            setFieldValue(name, v)
        }}
        getOptionLabel={(option: Tables<"product">) => {
            return option.Code + " " + option.Name;
        }}
        onInputChange={(e, v) => setFilter(v)}
        filterOptions={(v) => v}
        getOptionKey={o => o.id}
        renderOption={(props, option: Tables<"product">) => {
            const {key, ...rest} = props
            return <Box key={key} component="li" sx={{'& > .MuiAvatar-root': {mr: 1}}} {...rest}>
                <AvatarImage image_url={option.image_url} bucket={"products"}/> {option.Code} {option.Name}
            </Box>
        }}
        renderInput={(params) => (
            <TextField
                {...params}
                label={label}
                error={Boolean(error)}
                helperText={error}
            />
        )}
    />

}
